(function () {
  'use strict';

  if (window.PooleaseVariantNavigation) return;

  function buildUrl(productUrl, variantId) {
    var target = new URL(productUrl, window.location.origin);
    target.searchParams.set('variant', String(variantId));
    return target;
  }

  window.PooleaseVariantNavigation = {
    go: function (productUrl, variantId) {
      if (!productUrl || !variantId) return;
      var target = buildUrl(productUrl, variantId);
      if (target.href === window.location.href) return;
      window.location.assign(target.href);
    }
  };
})();
